<template>
  <div class="deck-template-selector">
    <h2 class="title is-3">Pick a starting point for your slides:</h2>
    <div class="columns">
      <div class="column is-1">
        <b-button
          @click="togglePage(-1)"
          v-if="page > 0"
          :disabled="page === 0"
          icon-pack="fas"
          icon-left="chevron-left"
          class="deck-template-selector__pagination-button"
        />
      </div>
      <div class="column">
        <TransitionGroup :name="'fade'" tag="div" class="deck-template-selector__list" data-cy="template-selector">
          <div
            v-for="(template, key) in pagedTemplates"
            :key="template.id || Math.random()"
            :tabindex="key + tabIndexOffset"
            @click="createFromTemplate(template)"
            class="deck-template-selector__list__item"
          >
            <img
              :src="template.img ? '/illustrations/' + template.img : '/facetime-meeting-alt.svg'"
              :style="template.scale ? 'transform: scale(' + template.scale + ');' : ''"
              alt="Facetime Meeting"
            >
            <h3>{{ template.name }}</h3>
          </div>
        </TransitionGroup>
      </div>
      <div class="column is-1">
        <b-button
          @click="togglePage()"
          v-if="page !== numPages - 1"
          :disabled="page === numPages - 1"
          icon-pack="fas"
          icon-left="chevron-right"
          class="deck-template-selector__pagination-button"
        />
      </div>
    </div>
    <div class="deck-template-selector__footer">
      Or choose from popular pre-made decks
      <n-link
        @click.native="trackBrowseAndClose"
        :tabindex="templates.length + tabIndexOffset"
        to="/templates"
        class="button is-primary"
      >
        Browse Ready to Play
      </n-link>
    </div>
  </div>
</template>

<script>
import { templateDecks, templateDecksForEdu } from '~/common/decks'

export default {
  name: 'DeckTemplateSelector',
  data () {
    return {
      tabIndexOffset: 10,
      templates: this.$store.state.user.isEdu ? templateDecksForEdu : templateDecks,
      page: 0,
      pageSize: 6
    }
  },
  computed: {
    numPages () {
      return Math.ceil(this.templates.length / this.pageSize)
    },
    pagedTemplates () {
      const start = this.page * this.pageSize
      return this.templates.slice(start, start + this.pageSize)
    }
  },
  methods: {
    togglePage (direction = 1) {
      this.page += direction
      this.posthogCapture('onboard:template_selector_paginate', { to_page: this.page })
    },
    createFromTemplate (template) {
      this.$emit('create', template)
      this.close()
    },
    trackBrowseAndClose () {
      this.posthogCapture('onboard:template_selector_cancel', { exit_to: 'browse' })
      this.close()
    },
    close (emit) {
      this.$parent.close()
    }
  }
}
</script>

<style scoped lang="scss">
@import "/assets/css/components";

.deck-template-selector {
  background-color: $white;
  border: 1px solid $border-color;
  border-radius: $border-radius-sm;
  padding: $padding-5;
  text-align: center;

  .columns .is-1 {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (max-height: 860px) {
    .deck-template-selector__footer {
      display: none;
    }
  }

}

h2.title {
  margin: $margin-3 auto 0;
}

.deck-template-selector__pagination-button {
  flex-grow: 0;
  border-radius: 9999px;
}

.deck-template-selector__list {
  margin: $margin-6 auto $margin-4;
  display: grid;
  // grid-auto-flow: column;
  grid-template-rows: 1fr 1fr;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: $padding-3;
  width: 100%;
  height: 25em;
  max-height: 25em;
  max-width: 745px;
  overflow: hidden;
}

@media (max-width: 800px) {
  .deck-template-selector__list {
    grid-auto-flow: row;
    grid-template-columns: 1fr 1fr;
    max-width: none;
    overflow-y: auto;
  }
}

@media (max-width: 520px) {
  .deck-template-selector__list {
    grid-template-columns: 1fr;
  }
}

.deck-template-selector__list__item {
  padding: 40px 50px 30px;
  font-size: $font-size-3;
  font-weight: 500;
  background: $light-bg;
  border-radius: $border-radius-sm;
  transition: all .13s ease;
  border: 1px solid $border-color;
  height: 216px;

  img {
    max-width: 100%;
    max-height: 100px;
    margin: 0 auto;
    display: block;
  }

  h3 {
    margin-top: $margin-3;
    font-weight: bold;
    font-size: $font-size-4;
  }

  &:hover, &:focus {
    cursor: pointer;
    background: #f0faff;
    border-color: #b6e2f8;
  }
}

.deck-template-selector__footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: $padding-3;
  margin: -$margin-5;
  margin-top: $margin-5;
  padding: $padding-5;
  background: $light-bg;
  border-top: 1px solid $border-color;
}
</style>
